// extracted by mini-css-extract-plugin
module.exports = {"root":"VmNode_root__2TFdU","title":"VmNode_title__2BP11","osIcon":"VmNode_osIcon__2Gqsi"};